import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import SendIcon from '@mui/icons-material/Send';
import { PageContainer, PageSection } from '../../../../ui';
import { layout } from '../../../../theme/tokens';
import ChatMessage from '../../Common/ChatMessage';
import actions from '../../../../redux/actions';
import { messageKey } from '../../../../util/useFlashOnView';
// import Chat from '../../../../next/chat/Chat';

const mapStateToProps = (state) => {
  return {
    user: state.user,
    cycles: state.cycles,
    chatMessages: state.chatMessages,
    device: state.resolution.device,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    listChatMessages: (cycleId, participantId) =>
      dispatch(actions.listChatMessages(cycleId, participantId)),
    markMessagesAsRead: (cycleId, participantId) =>
      dispatch(actions.markMessagesAsRead(cycleId, participantId)),
    sendChatMessage: (cycleId, receiverId, messageText) =>
      dispatch(actions.sendChatMessage(cycleId, receiverId, messageText)),
  };
};

class Messages extends Component<any> {
  public state: any;
  private markingAsRead = false;

  constructor(props) {
    super(props);

    this.state = {
      cycleId: +props.match.params.id,
      participants: [],
      participantId: null,
      messageText: '',
      newMessageKeys: new Set<string>(),
    };
  }

  componentDidMount() {
    if (!this.props.cycles.length) {
      return;
    }
    const cycle = this.props.cycles.find((el) => el.id === this.state.cycleId);
    const participantId = cycle.ownerId;

    this.setState({
      cycle,
      participantId,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    // if (! _.isEqual(this.props.cycles, prevProps.cycles)) {
    //     const cycle = this.props.cycles.find(el => el.id === this.state.cycleId);
    //     const participantId = cycle.ownerId;

    //     this.setState({
    //         cycle,
    //         participantId
    //     });
    // }

    // if (this.state.participantId !== prevState.participantId) {
    //     this.props.markMessagesAsRead(this.state.cycleId, this.state.participantId);
    // }

    // Opened by URL before the cycle list arrived: pick the cycle up once it's there
    if (this.state.participantId === null) {
      const cycle = this.props.cycles.find((el) => el.id === this.state.cycleId);
      if (cycle) {
        this.setState({ cycle, participantId: cycle.ownerId });
      }
      return;
    }

    this.markIncomingAsRead();
  }

  /* Incoming messages that are still unread flash once, then get marked read, which also
     clears the Messages count in the sidebar. Their keys are kept so they keep flashing
     after the store flips them to read. */
  markIncomingAsRead = () => {
    const { cycleId, participantId } = this.state;
    const messages = this.props.chatMessages.byCycleId[cycleId]?.[participantId] || [];
    const unread = messages.filter((message) => !message.read && message.senderId !== this.props.user.id);

    if (!participantId || !unread.length || this.markingAsRead) {
      return;
    }

    this.markingAsRead = true;
    this.setState((state: any) => ({ newMessageKeys: new Set([...state.newMessageKeys, ...unread.map(messageKey)]) }));
    Promise.resolve(this.props.markMessagesAsRead(cycleId, participantId)).finally(() => {
      this.markingAsRead = false;
    });
  };

  onInput = (event, data) => {
    this.setState({
      messageText: data.value,
    });
  };

  onSend = () => {
    if (!this.state.messageText.length) {
      return;
    }

    this.props.sendChatMessage(
      this.state.cycleId,
      this.state.participantId,
      this.state.messageText
    );
    this.setState({ messageText: '' });
  };

  getNameById = (id) => {
    if (id === this.props.user.id) {
      return `${this.props.user.firstName} ${this.props.user.lastName}`;
    }

    const name = this.props.cycles.find((el) => el.id === this.state.cycleId).ownerCompanyName;

    return name;
  };

  render() {
    const cycleId = this.state.cycleId;

    if (!this.props.cycles.length) {
      return null;
    }

    const cycle = this.props.cycles.find((cycle) => cycle.id === cycleId);
    const chatMessages = this.props.chatMessages.byCycleId[cycleId];
    const currentMessages = chatMessages?.[this.state.participantId] || [];

    const isMobile = this.props.device === 'mobile' || this.props.device === 'mobile-tablet';

    return (
      <PageContainer isMobile={isMobile}>
        <PageSection title={`Chat with ${cycle.ownerCompanyName || 'the customer'}`} padding={isMobile ? 1.5 : 2.5}>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
            Contact person: {cycle.contactPerson}
          </Typography>

          <Box sx={{ maxWidth: layout.readingWidth, mx: 'auto' }}>
          {currentMessages.length ? (
            currentMessages.map((message, i) => (
              <ChatMessage
                key={i}
                own={message.senderId === this.props.user.id}
                name={this.getNameById(message.senderId)}
                text={message.text}
                time={message.createdAt}
                avatarUrl={message.senderAvatarUrl}
                highlight={this.state.newMessageKeys.has(messageKey(message))}
              />
            ))
          ) : (
            <Typography variant="body2" color="textSecondary" sx={{ my: 2 }}>
              No messages yet
            </Typography>
          )}

          <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
            <TextField
              placeholder="Write a message…"
              value={this.state.messageText}
              onChange={(event) => this.onInput(event, { value: event.target.value })}
              multiline
              minRows={3}
              fullWidth
            />
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Button variant="contained" endIcon={<SendIcon />} disabled={!this.state.messageText.trim()} onClick={this.onSend}>
                Send
              </Button>
            </Box>
          </Box>
          </Box>
        </PageSection>
      </PageContainer>
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Messages));
